import request from "@/utils/request";

// 充电桩监控

// 统计设备当前状态
export const getDeviceStatusStats = params => {
	return request({
		url: "/device/status/stats",
		method: "GET",
		params,
	});
};
// 查询设备当前状态
export const getDeviceStatus = params => {
	return request({
		url: "/device/status",
		method: "GET",
		params,
	});
};

// 重启设备
export const restartDevice = data => {
	return request({
		url: "/device/restart",
		method: "POST",
		data,
	});
};

// 查询设备重启结果
export const getDeviceRestartStatus = params => {
	return request({
		url: "/device/restart/status",
		method: "GET",
		params,
	});
};
